module.exports = __webpack_public_path__ + "img/symbol_10.92d383ff.png";